export default "__VITE_ASSET__BOJ9$kqa__"